module.exports = __webpack_public_path__ + "img/VITALSSYSCS4.7f2e0419.jpg";